import type { NetlifyCountry } from '#types/locationSelector'

export default defineNuxtPlugin(() => {
  (async () => {
    const { enableLanguagePreference } = useFeatureFlags()
    
    if (!enableLanguagePreference) return
    
    const appCountryCode = useCountryCode()
    const { DialogLanguagePreference } = useDialogsStore()
    const { $gtm } = useNuxtApp() 
    const [lang] = navigator.language.split('-')

    if (enableLanguagePreference) {
      const languagePreference = useSessionStorage('languagePreference', null)

      if (languagePreference.value) return

      const [userCountry]: [NetlifyCountry['country']] = await Promise.all([
        $fetch<NetlifyCountry>('/get-user-geo-country').then((data) => data.country)
      ])

      const userCountryCode = userCountry?.code?.toLowerCase()

      if ((lang.toLowerCase() === 'es' || userCountryCode === 'es') && appCountryCode === 'US') {
        DialogLanguagePreference.open({
          expectedLanguage: lang
        })
        $gtm.push('languageSelector.onImpression')
      }
    }
  })()
})
